<template>
  <div id="dod32" class="dod32">
    <div class="dod32_grid_item">
      <div class="dod32_playButton js-spring" v-touchfeedback>
        <span class="dod32_playButton_button js-spring-target">
          Play
        </span>
      </div>
    </div>
    <div class="dod32_grid_item">
      <div class="dod32_budge js-spring" v-touchfeedback>
        <div class="dod32_budge_inner">
          <span class="dod32_budge_icon js-spring-target">
            →
          </span>
          <span class="dod32_budge_text">
            <span class="dod32_budge_text_title">Days of Design</span>
            <span class="dod32_budge_text_label">View More</span>
          </span>
        </div>
      </div>
    </div>
    <div class="dod32_grid_item">
      <div class="dod32_contactButton js-spring" v-touchfeedback>
        <span class="dod32_contactButton_button js-spring-target">
          Send
        </span>
      </div>
    </div>
    <div class="dod32_grid_item">
      <div class="dod32_budgeType2 js-spring" v-touchfeedback>
        <div class="dod32_budgeType2_bg js-spring-target" data-spring="reverse"></div>
        <div class="dod32_budgeType2_inner">
          <span class="dod32_budgeType2_icon js-spring-target">
            →
          </span>
          <span class="dod32_budgeType2_text">
            <span class="dod32_budgeType2_text_title">Days of Design</span>
            <span class="dod32_budgeType2_text_label">View More</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import currentDevice from 'current-device'
import { TweenMax, Elastic } from 'gsap/TweenMax'

export default {
  name: 'dod32',

  data: () => ({
    ready: false,
    mouse: {
      x: 0,
      y: 0,
      sx: 0,
      sy: 0,
      cx: 0,
      cy: 0
    }
  }),

  methods: {
    init() {
      const targets = [...document.querySelectorAll('#dod32 .js-spring')]

      targets.forEach(item => {
        item.addEventListener('mouseenter', this.onMouseEnter, false)
        item.addEventListener('mouseleave', this.onMouseLeave, false)
        item.addEventListener('touchstart', this.onMouseEnter, false)
        item.addEventListener('touchend', this.onMouseLeave, false)
      })

      window.addEventListener('mousemove', this.onWindowMouseMove, false)
      window.addEventListener('touchmove', this.onWindowMouseMove, false)
    },

    destroy() {
      const targets = [...document.querySelectorAll('#dod32 .js-spring')]

      targets.forEach(item => {
        item.removeEventListener('mouseenter', this.onMouseEnter, false)
        item.removeEventListener('mouseleave', this.onMouseLeave, false)
        item.removeEventListener('touchstart', this.onMouseEnter, false)
        item.removeEventListener('touchend', this.onMouseLeave, false)
      })

      window.removeEventListener('mousemove', this.onWindowMouseMove, false)
      window.removeEventListener('touchmove', this.onWindowMouseMove, false)
    },

    onWindowMouseMove(e) {
      let x = 0
      let y = 0

      if (e.touches && e.touches[0]) {
        x = e.touches[0].clientX
        y = e.touches[0].clientY
      } else if (e.originalEvent && e.originalEvent.changedTouches[0]) {
        x = e.originalEvent.changedTouches[0].clientX
        y = e.originalEvent.changedTouches[0].clientY
      } else if (e.clientX && e.clientY) {
        x = e.clientX
        y = e.clientY
      }

      this.mouse.sx = x
      this.mouse.sy = y

      this.onMouseMove()
    },

    onMouseEnter(e) {
      this.ready = true
      this.el = e.target
      this.springs = [...e.target.querySelectorAll('.js-spring-target')]

      const { width, height } = this.el.getBoundingClientRect()
      this.w = width
      this.h = height

      // cursor.onMouseLeave()
    },

    onMouseMove() {
      if (!this.ready) {
        return
      }

      const rect = this.el.getBoundingClientRect()

      this.tx = 2 * ((this.mouse.sx - rect.left) / this.w - 0.5)
      this.ty = 2 * ((this.mouse.sy - rect.top) / this.h - 0.5)

      this.springs.forEach(el => {
        this.dx = (el.dataset.spring === 'reverse') ? -180 * this.tx * Math.PI / 180 : 180 * this.tx * Math.PI / 180
        this.dy = (el.dataset.spring === 'reverse') ? -180 * this.ty * Math.PI / 180 : 180 * this.ty * Math.PI / 180

        TweenMax.to(el, 0.2, {
          rotation: 1 * this.dx + 'deg',
          x: 10 * this.dx + 'px',
          y: 10 * this.dy + 'px'
        })
      })
    },

    onMouseLeave(e) {
      this.ready = false

      TweenMax.to(this.springs, 0.8, {
        rotation: '0deg',
        x: '0px',
        y: '0px',
        ease: Elastic.easeOut.config(1.3, 0.3)
      })

      this.springs = []
    }
  },

  beforeDestroy() {
    this.destroy()
  },

  mounted() {
    this.init()
  }
}
</script>

<style scoped lang="scss">
.dod32 {
  @include FR_FULLSIZE;
  @include FR_FLEX_LAYOUT(center, center, wrap);

  padding-top: 10%;
  padding-bottom: 10%;
}

.dod32_grid_item {
  @include FR_FLEX_LAYOUT(center, center);

  min-width: 50%;
  min-height: 50%;
  max-height: 50%;
  position: relative;
}

// ===========================================
// dod32_playButton
// ===========================================
.dod32_playButton {
  @include FR_WH(8rem);

  position: relative;
}

.dod32_playButton_button {
  @include FR_FULLSIZE;
  @include FR_FLEX_LAYOUT(center, center);

  border: 1px solid currentColor;
  font-size: 120%;
  border-radius: 100%;
}

// ===========================================
// dod32_contactButton
// ===========================================
.dod32_contactButton {
  display: block;
  position: relative;
}

.dod32_contactButton_button {
  @include FR_FLEX_LAYOUT(center, center);

  position: relative;
  padding: 2rem 5rem;
  border-radius: 4px;
  width: 100%;
  background-color: #000000;
  color: #ffffff;
  font-size: 120%;
  cursor: pointer;
}

// ===========================================
// dod32_budge
// ===========================================
.dod32_budge {
  display: inline-block;
  position: relative;
  height: 74px;
  cursor: pointer;
}

.dod32_budge_inner {
  @include FR_FLEX_LAYOUT(flex-start, center);

  width: 100%;
  height: 100%;
}

.dod32_budge_icon {
  @include FR_FLEX_LAYOUT(center, center);
  @include FR_WH(5rem, 'flex');

  border-radius: 100%;
  margin-right: 1.5rem;
  background-color: #000000;
  color: #ffffff;
  font-size: 2rem;
}

.dod32_budge_text {
  display: block;

  > span {
    display: block;
  }
}

.dod32_budge_text_title {
  font-size: 120%;
  font-weight: bold;
}

.dod32_budge_text_label {
  font-size: 90%;
}

// ===========================================
// dod32_budgeType2
// ===========================================
.dod32_budgeType2 {
  display: inline-block;
  position: relative;
  height: 74px;
  cursor: pointer;
  color: #ffffff;
}

.dod32_budgeType2_bg {
  @include FR_FULLSIZE;

  top: -5px;
  left: -2rem;
  width: calc(100% + 4rem);
  height: calc(100% + 10px);
  border-radius: 4px;

  background-color: #000000;

  .is-touch & {
    background-color: darken(#000000, 8%);
  }
}

.dod32_budgeType2_inner {
  @include FR_FLEX_LAYOUT(flex-start, center);

  width: 100%;
  height: 100%;
  position: relative;
}

.dod32_budgeType2_icon {
  @include FR_FLEX_LAYOUT(center, center);
  @include FR_WH(4rem, 'flex');

  border-radius: 100%;
  margin-right: 1.2rem;
  background-color: #ffffff;
  color: #000000;
  font-size: 2rem;

  .is-touch & {
    background-color: darken(#ffffff, 8%);
  }
}

.dod32_budgeType2_text {
  display: block;

  > span {
    display: block;
  }
}

.dod32_budgeType2_text_title {
  font-size: 120%;
  font-weight: bold;
}

.dod32_budgeType2_text_label {
  font-size: 90%;
}
</style>
